<script setup lang="ts">
import DefaultLayout from "@/components/layouts/DefaultLayout.vue";
import { ref } from "vue";
import { gql } from "@apollo/client/core";
import { useMutation } from "@vue/apollo-composable";
import { useAuthStore } from "@/stores/auth";
import { ClientError, getMessageFromError } from "@/libs/errors";
import UserArea from "../../components/ui/UserArea.vue";

const displayModeMobile = ref(false);
const authStore = useAuthStore();
const currentPassword = ref("");
const errorMessage = ref("");
const newPassword = ref("");
const newPasswordConfirmation = ref("");
const loading = ref(false);

const { mutate: updateUserPassword } = useMutation(
  gql`
    mutation UpdateMyPassword(
      $newPassword: String!
      $currentPassword: String!
    ) {
      updateMyPassword(
        newPassword: $newPassword
        currentPassword: $currentPassword
      )
    }
  `,
  {
    fetchPolicy: "no-cache",
  }
);

const submit = async () => {
  if (loading.value) {
    return;
  }
  loading.value = true;
  errorMessage.value = "";
  try {
    if (
      !currentPassword.value ||
      !newPassword.value ||
      !newPasswordConfirmation.value
    ) {
      throw new ClientError("Preencha todos os campos");
    }
    if (newPassword.value !== newPasswordConfirmation.value) {
      throw new ClientError(
        "Os campos da senha nova não são iguais. Tente novamente."
      );
    }
    await updateUserPassword({
      newPassword: newPassword.value,
      currentPassword: currentPassword.value,
    });
    alert("Senha alterada com sucesso.");
  } catch (err) {
    errorMessage.value = getMessageFromError(err);
  }
  loading.value = false;
};
</script>

<template>
  <DefaultLayout>
    <article class="container framework-slot">
      <div class="row">
        <div class="col">
          <UserArea title="Alterar Senha">
            <form @submit.prevent="submit">
              <div v-if="errorMessage" class="alert alert-danger">
                {{ errorMessage }}
              </div>
              <div class="row">
                <div class="col-md">
                  <div class="form-group mb-3">
                    <label for="passwordCurrent" class="form-label"
                      >Senha Atual</label
                    >
                    <div class="input-group">
                      <input
                        v-model="currentPassword"
                        type="password"
                        class="form-control"
                      />
                    </div>
                  </div>
                  <div class="form-group mb-3">
                    <label for="password" class="form-label">Nova Senha</label>
                    <div class="input-group">
                      <input
                        v-model="newPassword"
                        type="password"
                        class="form-control"
                      />
                    </div>
                  </div>
                  <div class="form-group mb-3">
                    <label for="passwordConfirm" class="form-label"
                      >Confirmar Senha</label
                    >
                    <div class="input-group">
                      <input
                        v-model="newPasswordConfirmation"
                        type="password"
                        class="form-control"
                      />
                    </div>
                  </div>
                  <button
                    v-if="loading"
                    class="btn btn-primary mb-3"
                    type="submit"
                    disabled
                  >
                    Salvando...
                  </button>
                  <button v-else class="btn btn-primary mb-3" type="submit">
                    Salvar Alterações
                  </button>
                </div>
                <div class="col-md">
                  <div class="form-group mb-3">
                    <label for="tip" class="form-label">Dica</label>
                    <div class="profileContentNav">
                      <p>
                        Escolha uma senha segura, que mescle letras maiuscúlas,
                        minuscúlas e números.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </UserArea>
        </div>
      </div>
    </article>
  </DefaultLayout>
</template>

<style scoped></style>
